import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../../lib/api";
import { Section } from "./PortalPage";
import { SubClientRow } from "./SubClientCards";
import { TreeStructure, ArrowRight } from "@phosphor-icons/react";

/* Dashboard panel for main clients: the busiest sub-clients at a glance, linking to the Sub-clients hub. */
export function SubClientsPanel({ limit = 5 }) {
  const [data, setData] = useState(null);
  useEffect(() => { API.get("/client-hub/sub-clients").then(({ data }) => setData(data)).catch(() => setData({ sub_clients: [] })); }, []);
  if (!data || !data.is_main) return null;
  const score = (s) => (s.counts?.active_emergencies || 0) * 5 + (s.counts?.awaiting_approval || 0) * 3 + (s.counts?.open_requests || 0) + (s.counts?.active_jobs || 0);
  const rows = [...data.sub_clients].sort((a, b) => score(b) - score(a)).slice(0, limit);
  return (
    <Section title={`Your sub-clients (${data.sub_clients.length})`} testid="dash-sub-clients"
      action={<Link to="/portal/sub-clients" className="text-xs text-primary hover:underline inline-flex items-center gap-1">All sub-clients <ArrowRight size={12} /></Link>}>
      {rows.length === 0 ? <p className="text-xs text-muted-foreground text-center py-4 inline-flex items-center gap-2 w-full justify-center"><TreeStructure size={14} /> No sub-clients yet.</p> : (
        <ul className="divide-y divide-border -mx-4 -my-4">{rows.map((s) => <SubClientRow key={s.id} sub={s} />)}</ul>
      )}
    </Section>
  );
}
